'use client';

import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Css, Responsive, ContentWrap } from '@/ui';
import { theme } from '../../../styles/theme';
import SecurityWaitTimesWidget, {
	SecurityWidgetContainer,
} from '../../security/ui/SecurityWaitTimesWidget';

export default function SecurityWaitTimesSection() {
	const [error, setError] = useState(false);

	if (error) {
		return null;
	}

	return (
		<SecurityWidgetWrap>
			<SecurityWaitTimesWidget onError={() => setError(true)} />
		</SecurityWidgetWrap>
	);
}

const SecurityWidgetWrap = styled.div`
	padding: ${Css.pxToRemFromTheme(24)} 0 0 0;

	${ContentWrap} {
		display: grid;
		grid-column-gap: ${theme.grid?.gutter?.vertical?.default};
		grid-template-columns: 2fr 1fr;
	}

	${SecurityWidgetContainer} {
		grid-column: span 1;
		max-width: 100%;

		@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
			grid-column: span 2;
		}
	}
`;
